(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'multiColumnList', {
            bindings: {
                content:    '<',
            },
            templateUrl:    'app/views/partials/content/multi-list.html',
            controller:     MultiColumnListController,
            controllerAs:   'vm',

            renderingOptions: {
                'multi-list': {
                    inputs:    [
                        'content="::content.asset_contents"'
                    ],
                    wrapStart:  '<div class="centraliser block-container">',
                    wrapEnd:    '</div>'
                }
            }
        });


        function MultiColumnListController(){

            // Helper members.

            /** @type {angular.IController} */
            var vm = this;
        }


        //MultiColumnListController.$inject = [];
})();
